import { z } from 'zod';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
export const mechanicRobberStateSchema = z.object({
    locationTileIndex: z.number().int().nonnegative(),
    isActive: z.boolean()
}).strict();
export function validateMechanicRobberState(data) {
    return validateState(mechanicRobberStateSchema, data);
}
export const mechanicRobberStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicRobberStateSchema);
